import { Modal } from 'antd'
import styled from 'styled-components'

export const FullWidthModal = styled(Modal)`
  width: 90% !important;
  font-size: inherit;
  padding: 0;
`
